module.exports = __webpack_public_path__ + "img/achievement-course7.55275156.png";